export default __webpack_public_path__ + "image-object9bbbb9.png";